export default "__VITE_ASSET__CjDVdzj0__"